import { useState, useEffect, useMemo } from "react";

import { makeStyles, Typography } from "@material-ui/core";

import { api } from "../../../../services/api";
import { CARBON_REVENUES_COLORS } from "../../constants";
import { requestDateFormat, capitalize, onlyUniqueValuesOfKeyInArray } from "../../../../services/utils";
import { ShaDowBox } from "../../../../components/boxes/ShadowBox";
import { PieChart } from "../../../../components/charts/PieChart";
import { PieLegends } from "../../../../components/charts/PieLegends";
import { NoDataCard } from "../../../../components/parts";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(3)}px ${theme.spacing(3.5)}px`,
  },
}));

export const CarbonRevenueTotal = ({ period, startDate, endDate }) => {
  const classes = useStyles();
  const [data, setData] = useState([]);

  const title = "Carbon Revenue - Total";

  useEffect(() => {
    const getTotal = (url) => {
      api.get(url).then((resp) => {
        if (!onlyUniqueValuesOfKeyInArray(resp.data.results, 'value', 0)) {
          const data = resp.data.results.map((item) => ({
            formatType: "inline",
            name: capitalize(item.name),
            value: item.value,
            displayValue: item.value,
            legendValue: item.value,
            key: item.name,
          }));
          setData(data);
        }
      });
    };

    const getUrl = (period) => {
      let url = "/praas/v1/emission-impact/carbon-revenues/total/";
      if (period.name === "RANGE" && endDate) {
        url += `?from_date=${requestDateFormat(
          startDate
        )}&to_date=${requestDateFormat(endDate)}`;
        getTotal(url);
      } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
        url += `?date_filter=${period.filter}`;
        getTotal(url);
      }
    };

    getUrl(period);
  }, [period, startDate, endDate]);

  const getData = useMemo(() => {
    return data.filter((val) => val.value);
  }, [data]);

  return (
    <ShaDowBox style={{ width: "100%" }}>
      {data.length ? (
        <div className={classes.box} id="carbon-revenue-total">
          <Typography variant="h4">{title}</Typography>
          <PieChart
            data={getData}
            colors={CARBON_REVENUES_COLORS}
            name="CarbonRevenue"
          />
          <PieLegends data={data} colors={CARBON_REVENUES_COLORS} xs={5} />
        </div>
      ) : <NoDataCard title={title} type="pie" />}
    </ShaDowBox>
  );
};
